module.exports = __webpack_public_path__ + "img/im_scrollfeature_13.eb098d99.jpg";